class FlickPatch {  //  Flick Carousel ARIA-HIDDEN observer
  constructor(_d, _sQ) {
      this._d = _d; this._sQ = _sQ;
      this.aF = []; this.aObs = [];
  }
  init() {  //
      this.aF = Array.from( this._d.querySelectorAll( this._sQ ))
      if( this.aF.length ){
          this.aObs = []
          this.aF.forEach( ( eF )=>{
              const oObs = new MutationObserver( flickPatch.removeAttr );
              oObs.observe( eF, { attributes: true, childList: true, subtree: true } );
              this.aObs.push( oObs )
          })            
      }
      return this;
  }
  removeAttr( aObs ){  //
      if( aObs.length ){
          aObs.forEach( ( elO )=>{
              if( elO?.target ){
                  [ ... elO.target.querySelectorAll( "[aria-hidden='true']" )].forEach( ( eH )=>{
                      eH.removeAttribute("aria-hidden")
                  })
              }
          })
      }
  }
}
//. Usage
let flickPatch = {}
document.addEventListener("DOMContentLoaded", ( ev )=>{
  setTimeout( ()=>{
      flickPatch = new FlickPatch( document, ".flickity-slider" )
      flickPatch.init()   
  }, 8e3 )
})

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

var scroll_links = document.querySelectorAll('a.smooth-scroll');
if (scroll_links.length > 0) scroll_links.forEach(link => link.addEventListener('click', (e) => {

  e.preventDefault();

  var element = document.querySelector(e.target.closest('a.smooth-scroll').getAttribute('href'));
  var headerOffset = document.querySelector('sticky-header').offsetHeight;

  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });

}));

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }


  




  connectedCallback() {





    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }




        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class PartFinder extends HTMLElement {
  constructor() {
    super();
    this.partFinderHolder = this.querySelector('.holder');
    this.errorText = this.querySelector('.error-text')

    var product_page = window.parts_finder ? true : false;
    this.initPartFinder([], product_page);

  }

  handleize(str) {
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
      .replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
      .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
      .toLowerCase(); // To lowercase
    return str
  }

  isOptionValueExists(selectElement, targetValue) {
    for (let i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].value === targetValue) {
            return true; // Option value exists
        }
    }
    return false; // Option value does not exist
}

  async initPartFinder(searchParams, product_page) {

    this.partFinderHolder.classList.add('loading');

    var part_finder_html = await this.getPartFinder(searchParams);
    var html = await part_finder_html.text().then(async (html) => { return html });

    var myDiv = document.createElement('div');
    myDiv.innerHTML = html;
    this.partFinderHolder.innerHTML = myDiv.innerHTML;

    this.partFinderHolder.classList.remove('loading');
    
    const userVehicleCookie = this.getCookie('userVehicle');
    if (userVehicleCookie) {
      const userVehicle = JSON.parse(userVehicleCookie);
      console.log(userVehicle);
      const partsFinderHeader = document.querySelector('.parts-finder-header');
      partsFinderHeader.innerText = userVehicle.Makes;

      const partFinderSelector = document.querySelector('#makes-select');
      console.log(partFinderSelector);
      partFinderSelector.value = `filter.p.m.custom.makes=${userVehicle.Makes}`;

      if (userVehicle.Makes === 'Makes') {
        partFinderSelector.selectedIndex = 0;
      }
    }
    
    if (product_page) {
      if (window.parts_finder.Make != '') {
        var option_exists = this.isOptionValueExists(this.partFinderHolder.querySelector('.select-dropdown[name="Make"]'), 'filter.p.m.custom.make=' + window.parts_finder.Make)
        if(option_exists){
          this.partFinderHolder.querySelector('.select-dropdown[name="Make"]').value = 'filter.p.m.custom.make=' + window.parts_finder.Make
        } else {
          var option = document.createElement('option');
          option.value = 'filter.p.m.custom.make=' + window.parts_finder.Make;
          option.text = window.parts_finder.Make;
          this.partFinderHolder.querySelector('.select-dropdown[name="Make"]').add(option);
          this.partFinderHolder.querySelector('.select-dropdown[name="Make"]').value = 'filter.p.m.custom.make=' + window.parts_finder.Make
        }
      }
      if (window.parts_finder.Model != '') {
        var option_exists = this.isOptionValueExists(this.partFinderHolder.querySelector('.select-dropdown[name="Model"]'), 'filter.p.m.custom.model=' + window.parts_finder.Model)
        if(option_exists){
          this.partFinderHolder.querySelector('.select-dropdown[name="Model"]').value = 'filter.p.m.custom.model=' + window.parts_finder.Model
        } else {
          var option = document.createElement('option');
          option.value = 'filter.p.m.custom.model=' + window.parts_finder.Model;
          option.text = window.parts_finder.Model;
          this.partFinderHolder.querySelector('.select-dropdown[name="Model"]').add(option);
          this.partFinderHolder.querySelector('.select-dropdown[name="Model"]').value = 'filter.p.m.custom.model=' + window.parts_finder.Model
        }        
      }
      if (window.parts_finder.Product_Type != '') {
        // Check if the option exists in the "Part Type" dropdown
        var option_exists = this.isOptionValueExists(
          this.partFinderHolder.querySelector('.select-dropdown[name="Part Type"]'),
          'filter.p.product_type=' + window.parts_finder.Product_Type.replace(' ', '+')
        );
        if (option_exists) {
          // Set the dropdown's value if the option exists
          this.partFinderHolder.querySelector('.select-dropdown[name="Part Type"]').value =
            'filter.p.product_type=' + window.parts_finder.Product_Type.replace(' ', '+');
        } else {
          // Create a new option and add it to the dropdown if the option doesn't exist
          var option = document.createElement('option');
          option.value = 'filter.p.product_type=' + window.parts_finder.Product_Type.replace(' ', '+');
          option.text = window.parts_finder.Product_Type;
          this.partFinderHolder.querySelector('.select-dropdown[name="Part Type"]').add(option);
          this.partFinderHolder.querySelector('.select-dropdown[name="Part Type"]').value =
            'filter.p.product_type=' + window.parts_finder.Product_Type.replace(' ', '+');
        }
      }
      if (window.parts_finder.Year != '') {
        // Check if the option exists in the "Year" dropdown
        var option_exists = this.isOptionValueExists(
          this.partFinderHolder.querySelector('.select-dropdown[name="Year"]'),
          'filter.p.m.custom.year=' + window.parts_finder.Year
        );
        if (option_exists) {
          // Set the dropdown's value if the option exists
          this.partFinderHolder.querySelector('.select-dropdown[name="Year"]').value =
            'filter.p.m.custom.year=' + window.parts_finder.Year;
        } else {
          // Create a new option and add it to the "Year" dropdown if the option doesn't exist
          var option = document.createElement('option');
          option.value = 'filter.p.m.custom.year=' + window.parts_finder.Year;
          option.text = window.parts_finder.Year;
          this.partFinderHolder.querySelector('.select-dropdown[name="Year"]').add(option);
          this.partFinderHolder.querySelector('.select-dropdown[name="Year"]').value =
            'filter.p.m.custom.year=' + window.parts_finder.Year;
        }
      }
    }

    this.submitButton = this.partFinderHolder.querySelector('.search-btn');
    this.submitButton.addEventListener('click', this.submitClick.bind(this));
    // Lets assign change events to all selects
    this.selects = this.partFinderHolder.querySelectorAll('select');

    if (this.selects.length > 0) {
      this.selects.forEach((select) => {
        select.addEventListener('change', this.selectChange.bind(this, product_page))
      })
    }

    this.updateButton();
  }

  submitClick(event) {
    const selectValues = {};
    this.selects.forEach((select) => {
      selectValues[select.name]=select.options[select.selectedIndex].text;
    })
    this.setCookie('userVehicle', JSON.stringify(selectValues), 7);
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Set expiration
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; ${expires}; path=/`;
  }

  getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return JSON.parse(decodeURIComponent(value));
      }
    }
    return null; // Return null if the cookie doesn't exist
  }

  updateButton(product_page) {
    var filters = ['sort_by=best-selling']
    var make = 'all';

    this.selects.forEach((select) => {
      if (select.value !== 'none') filters.push(select.value)
      if (select.value.includes('custom.make')) make = this.handleize(select.value.split('=')[1]);
      if (select.value.includes('p.product_type')) make = this.handleize(select.value.split('=')[1]);
    });

    var searchParams = filters.join('&');
    this.submitButton.href = '/collections/' + make + '/?' + searchParams;

    return searchParams;
  }

  selectChange(product_page, e) {

    if (product_page) {
      this.selects.forEach((select) => {
        if (select !== e.target) {
          select.selectedIndex = 0
        }
      })
    }

    var searchParams = this.updateButton();
    // this.initPartFinder(searchParams, false)
  }

  async getCollectionJson(handle) {
    return fetch(`/collections/${handle}.json`).then(async (response) => {
      var json = await response.json(); 

      console.log('json', json);

      return {
        status: response.status,
        collection: json.collection
      };
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  async getPartFinder(searchParams) {

    console.log('searchParams', searchParams)

    var collection_name = 'all';

    if(searchParams.length > 0){
        await this.asyncForEach(searchParams.split('&'), async (param) => {
          if(param.includes('custom.make') || param.includes('p.product_type')) {

            var collection_handle = this.handleize(param.split('=')[1]);
            var does_collection_exist = await this.getCollectionJson(collection_handle);

            if(does_collection_exist.status !== 404 && does_collection_exist.collection && does_collection_exist.collection.products_count > 0){
              collection_name = this.handleize(param.split('=')[1]);
            }
          }
        });

    }

    var parts_finder_url = `/collections/${collection_name}?view=parts-finder&${searchParams}&timestamp=`.concat(Date.now());

    console.log('parts_finder_url TESTING', parts_finder_url)

    return fetch(parts_finder_url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(async (content) => {

      if(content.status === 404){
        this.partFinderHolder.classList.remove('loading');
        this.errorText.innerHTML = '<span class="alert">Collection Not found</span>';
        return;
      }

      return content;
    }).catch((e) => {
      console.error(e);
    });
  }
}

customElements.define('part-finder', PartFinder);


class HeaderMenuParts extends HTMLElement {
  constructor() {
    super();
    this.menuItems = this.querySelectorAll('header-menu');
    if (this.menuItems.length > 0) this.getMenus();

    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });

      item.addEventListener("click", async (e) => {
          var part = e.target.closest('.part-name');
          var part_handle = part.dataset.partHandle;

          var collection_query = 'all'
          var part_collection = await this.getCollectionJson(part_handle);
          if(part_collection === 200){
            collection_query = part_handle
          }

          window.location.href = window.shopUrl + `/collections/${collection_query}?filter.p.product_type=${part.dataset.partName}&sort_by=best-selling`;
      });

    });
  }

  async getMenus() {
    await this.asyncForEach(this.menuItems, async (menu, i) => {
      var name = menu.querySelector('.part-name').dataset.partName;
      var part_handle = menu.querySelector('.part-name').dataset.partHandle;
      
      var part_finder_html = await this.getMenuItem(name, part_handle);
      var html = await part_finder_html.text().then(async (html) => { return html });
      var holder = menu.querySelector('.mega-menu__content');

      holder.innerHTML = html;
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  async getCollectionJson(handle) {
    return fetch(`/collections/${handle}.json`).then((response) => {
      return response.status;
    });
  }

  async getMenuItem(name, part_handle) {

    var collection_query = 'all'
    var part_collection = await this.getCollectionJson(part_handle);
    if(part_collection === 200){
      collection_query = part_handle
    }

    var parts_finder_url = `/collections/${collection_query}?view=menu-item&sort_by=best-selling&filter.p.product_type=${name}&filter.v.price.gte=&filter.v.price.lte=&timestamp=`.concat(Date.now());

    return fetch(parts_finder_url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(async (content) => {
      return content;
    });
  }

}

customElements.define('header-menu-parts', HeaderMenuParts);

class FlickitySlider extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector('.main-carousel');
    this.controls = this.closest('section').querySelector('.flickity-controls');
    this.buttons = this.controls.querySelectorAll('button');

    this.buttons.forEach(button => button.addEventListener('click', this.changeSlide.bind(this)))

    this.flickitySlider = new Flickity(this.carousel, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false
    });

  }

  changeSlide(event) {
    var button = event.target.closest('button');
    button.classList.contains('prev') ? this.flickitySlider.previous(true, false) : this.flickitySlider.next(true, false)
  }

  refresh() {
    new Flickity(this.carousel, {
      wrapAround: true
    });
  }
}
customElements.define('flickity-slider', FlickitySlider);


class CollectionDescription extends HTMLElement {
  constructor() {
    super();
    
    var content_area = this.querySelector('.content_area') || this.querySelector('.metafield-rich_text_field');
    const childNodes = content_area.childNodes;

    // Create a new div element
    const hiddenDiv = document.createElement('div');
    hiddenDiv.classList.add('extra-content');
    hiddenDiv.style.display = 'none';

    let shouldMove = false;
    let elementCount = 0;

    // Loop through child nodes
    for (let i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeType !== Node.ELEMENT_NODE) {
        continue; // Skip text nodes
      }

      elementCount++;
      if (shouldMove) {
        // Clone the child node and append it to the hidden div
        hiddenDiv.appendChild(childNodes[i].cloneNode(true));
        // Remove the original child node
        content_area.removeChild(childNodes[i]);
        // Decrement the counter since we removed a node
        i--;
      }
      // Check if we have moved past the first two element nodes
      if (!shouldMove && elementCount > 0) {
        shouldMove = true;
      }
    }

    // Append the hidden div after the content area
    content_area.parentNode.insertBefore(hiddenDiv, content_area.nextSibling);

    var read_more = this.querySelector('.read-more');
    if (read_more) {
      // Hide the read more link if hiddenDiv is empty
      if (hiddenDiv.textContent.trim() === '') {
        read_more.style.display = 'none';
      }

      read_more.addEventListener('click', (event) => {
        // Toggle display of the hidden div
        if (hiddenDiv.style.display === 'none') {
          hiddenDiv.style.display = 'block';
          read_more.textContent = 'Read Less';
        } else {
          hiddenDiv.style.display = 'none';
          read_more.textContent = 'Read More';
        }
      });
    }


  }

  
}
customElements.define('collection-description', CollectionDescription);







class CollectionList extends HTMLElement {
  constructor() {
    super();
    this.initSlideshowSlick();
  }
  initSlideshowSlick() {
    $('.collection-list').slick({
      slide: 'li',
      dots: false,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      slidesToShow: 6,
      slidesToScroll: 6,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: '10px'
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '100px'
          }
        }
      ]
    });
  }


}

customElements.define('collection-list', CollectionList);



class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.initSlideshowSlick();
  }
  initSlideshowSlick() {
    $('.featured-collection-slick').slick({
      slide: 'li',
      dots: false,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      slidesToShow: 4,
      slidesToScroll: 4,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            centerMode: true,
            centerPadding: '80px'
          }
        }
      ]
    });
  }


}

customElements.define('featured-collection', FeaturedCollection);

class FcImage extends HTMLElement {
  constructor() {
    super();
    this.initSlideshowSlick();
  }
  initSlideshowSlick() {
    $('.fc-image-slick').slick({
      slide: 'li',
      dots: false,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      slidesToShow: 2,
      slidesToScroll: 2,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            centerMode: true,
            centerPadding: '80px'
          }
        }
      ]
    });
  }


}

customElements.define('fc-image', FcImage);


class FcSovi extends HTMLElement {
  constructor() {
    super();
    const slickSelector = this.querySelectorAll('.mulitiple-collection-slick');

    if (slickSelector) {
      this.initSlideshowSlick();
    }

    const collectionLinks = this.querySelectorAll('.category-button');
    const sliderContainer = this.querySelectorAll('.category-slider');
    // const myTimeout = setTimeout(this.initSlider,1000);


    collectionLinks.forEach(f => {
      f.addEventListener('click', function (e) {
        const clicked = e.target.closest('.category-button');
        e.preventDefault();
        // Guard clause
        if (!clicked) return;

        // Remove active classes
        collectionLinks.forEach(t => t.classList.remove('active'));
        sliderContainer.forEach(t => t.classList.remove('active'));

        // Activate content area
        document.querySelector(`.${clicked.dataset.section} .category-slider--${clicked.dataset.button}`).classList.add('active');

        // Active button
        clicked.classList.add('active');
        
        $('.mulitiple-collection-slick').slick('refresh');
      }

    )

    });

  }

  initSlideshowSlick() {
    $('.mulitiple-collection-slick').slick({
      slide: 'li',
      dots: false,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      slidesToShow: 4,
      slidesToScroll: 4,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false,
            centerMode: false
          }
        }
      ]
    });
    // $('.collection-buttons').slick({
    //   slide: 'a',
    //   dots: false,
    //   arrows: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   mobileFirst: true,
    //   centerMode: true,
    //   centerPadding: '30px',
    //   responsive: [
    //     {
    //        breakpoint: 750,
    //        settings: "unslick"
    //     }
    //   ]
    // });
  }

  initSlider(){
    document.querySelectorAll('.category-slider').forEach(t => t.classList.remove('active'));
    document.querySelector('.category-slider--1').classList.add('active');
  }

}
customElements.define('fc-sovi', FcSovi);


class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.initSlideshowSlick();
  }
  initSlideshowSlick() {
    $('.rp-slick').slick({
      slide: 'li',
      dots: false,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg width="82" height="82" viewBox="0 0 53 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50423e-07 21C2.59909e-07 20.2045 0.348956 19.4416 0.970101 18.8791C1.59125 18.3165 2.4337 18.0005 3.31213 18.0005L41.6865 18.0005L27.4642 5.12686C27.1562 4.84798 26.912 4.51691 26.7453 4.15254C26.5786 3.78817 26.4929 3.39764 26.4929 3.00324C26.4929 2.60885 26.5786 2.21832 26.7453 1.85395C26.912 1.48958 27.1562 1.1585 27.4642 0.879624C27.7721 0.600746 28.1377 0.379528 28.5401 0.228604C28.9424 0.0776752 29.3737 -3.46442e-06 29.8092 -3.45923e-06C30.2447 -3.45403e-06 30.6759 0.0776752 31.0783 0.228604C31.4806 0.379528 31.8462 0.600747 32.1542 0.879624L52.0269 18.8764C52.3354 19.155 52.5801 19.486 52.7471 19.8504C52.9141 20.2148 53 20.6055 53 21C53 21.3945 52.9141 21.7852 52.7471 22.1496C52.5801 22.514 52.3354 22.845 52.0269 23.1236L32.1542 41.1204C31.8462 41.3992 31.4806 41.6205 31.0783 41.7714C30.6759 41.9223 30.2447 42 29.8092 42C29.3737 42 28.9424 41.9223 28.5401 41.7714C28.1377 41.6205 27.7721 41.3992 27.4642 41.1204C26.8423 40.5572 26.4929 39.7933 26.4929 38.9968C26.4929 38.6024 26.5786 38.2118 26.7453 37.8475C26.912 37.4831 27.1562 37.152 27.4642 36.8731L41.6865 23.9995L3.31213 23.9995C2.4337 23.9995 1.59125 23.6834 0.970101 23.1209C0.348956 22.5584 2.40936e-07 21.7955 2.50423e-07 21Z" fill="#FFFFFF"/></svg></button>',
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }


}

customElements.define('related-products', RelatedProducts);